// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3ZN_u","content":"RecentSearches_content__2nfKn"};